import Page from './page';
import masonryGallery from '../modules/masonry-gallery';
import lightBox from '../modules/gallery-lightbox';
import inView from '../modules/viewport';

const defaults = {};

export default class GalleryPage extends Page {

  constructor($context, options) {
    super($context, options);

    this.init();
  }

  init() {
    this.initModules();
  }

  initModules() {
    masonryGallery();
    lightBox();
    inView();
  }

  static initialize(selector = 'body') {
    return super.initialize(selector, GalleryPage, 'GalleryPage');
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/pages/gallery-page.js